import { ethers } from "ethers";

export const n6 = new Intl.NumberFormat("en-us", {
  style: "decimal",
  minimumFractionDigits: 0,
  maximumFractionDigits: 6,
});
export const n4 = new Intl.NumberFormat("en-us", {
  style: "decimal",
  minimumFractionDigits: 0,
  maximumFractionDigits: 4,
});

export const c2 = new Intl.NumberFormat("en-us", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Returns a string of form "abc...xyz"
 * @param {string} str string to string
 * @param {number} n number of chars to keep at front/end
 * @returns {string}
 */
export const getEllipsisTxt = (str, n = 6) => {
  if (str) {
    return `${str.slice(0, n)}...${str.slice(str.length - n)}`;
  }
  return "";
};

export const valueToToken = (value, decimals) =>
  decimals ? value * Math.pow(10, decimals) : value;

export const tokenValue = (value, decimals) =>
  decimals ? value / Math.pow(10, decimals) : value;

/**
 * Return a formatted string with the symbol at the end
 * @param {number} value integer value
 * @param {number} decimals number of decimals
 * @param {string} symbol token symbol
 * @returns {string}
 */
export const tokenValueTxt = (value, decimals, symbol) =>
  `${n4.format(tokenValue(value, decimals))} ${symbol}`;

// format ISOdate date to Month, Day Year
const yearMonthDate = (ISOdate) => {
  const date = new Date(ISOdate);
  const monthName = date.toLocaleString("default", { month: "short" });
  return monthName + ", " + date.getDate() + " " + date.getFullYear();
};

export const DateFormater = {
  yearMonthDate,
};

export function getDecimalPlaces(n) {
  var i = n.indexOf(".");
  return i > 0 ? n.length - i - 1 : 0;
}

export function moralisBigNumHexToDex(n) {
  if (n?._isBigNumber) return parseInt(n._hex, 16);
}

export function getHumanReadableAmount(amount) {
  if (amount === "0.00") return amount;
  let amt = amount ? ethers.utils.formatUnits(amount, 18) : "N/A";
  return getDecimalPlaces(amt.toString()) > 5
    ? parseFloat(amt).toFixed(5)
    : parseFloat(amt).toFixed(2);
}
